export { sampleCabinets, sampleCdn } from './sampleCabinets'
/** 云排版上传oss的基础文件路径 */
export const OSS_BASE_URL = 'cloud_paiban'
export * from './plankMapState'
